import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Box } from 'theme-ui';
import { useTranslation } from 'react-i18next';
import Accordion from './Accordion';
import AlertNotification from './AlertNotification';
import ContentfulForm from './ContentfulForm';
import LianaMailListForm from './LianaMailListForm';
import SalesAreaSearch from './SalesAreaSearch';
import TicketSearch from './TicketSearch';
import { TrackBySearch } from './TrackShipment';
import { AllParcelWidgets } from './widgets';
import BookingWidgetWide from './widgets/BookingWidgetWide';
import SMESelection from './SMESelection';
import MultiParcelWidgets from './widgets/MultiParcelWidgets';
import AbroadSelection from './AbroadSelection';

const ScriptComponent = ({ css, id, src }) => {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);
  if (!hasMounted) {
    return null;
  }

  return (
    <>
      <Helmet>
        {css && <link rel="stylesheet" type="text/css" href={css} />}
        <script type="text/javascript" src={src} />
      </Helmet>
      <div id={id}></div>
    </>
  );
};

const IFrameComponent = ({ id, style, ...rest }) => {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);
  if (!hasMounted) {
    return null;
  }

  return (
    <Box sx={{ my: 4 }}>
      <iframe style={style} {...rest}></iframe>
      <div id={id}></div>
    </Box>
  );
};

const ContentfulComponent = ({ template, title, data = {}, body, locale, assets, sxx, ...rest }) => {
  const { t: translate } = useTranslation();
  const selectComponent = (template) => {
    switch (template) {
      case 'LianaMailerForm':
        return <LianaMailListForm />;
      case 'Form':
        return <ContentfulForm title={title} data={data} {...rest} />;
      case 'Script':
        return <ScriptComponent {...data} />;
      case 'SalesAreaSearch':
        return <SalesAreaSearch {...data} assets={assets} />;
      case 'TicketSearch':
        return <TicketSearch {...data} assets={assets} />;
      case 'Notification':
        return <AlertNotification sxx={sxx} body={body} locale={locale} />;
      case 'ParcelWidget':
        return <AllParcelWidgets locale={locale} sxx={sxx} showHeader={false} center={true} />;
      case 'MultiParcelWidget':
        return <MultiParcelWidgets sxx={sxx} center={true} />;
      case 'IFrame':
        return <IFrameComponent {...data} />;
      case 'ParcelTracking':
        return (
          <Accordion
            title={translate('tracking.search.description2')}
            sx={{
              bg: 'white',
              border: '2px solid',
              borderColor: 'border',
              borderRadius: '8px',
              pl: 24,
              py: 2,
              my: 4,
              outline: 0,
            }}
            contentSx={{ color: undefined, '*:first-of-type': undefined, '*:last-of-type': undefined, pr: 24 }}
            disableOnKeyDown={true}
          >
            <TrackBySearch inlineTracking={true} />
          </Accordion>
        );
      case 'TicketWidget':
        return <BookingWidgetWide sxx={sxx} />;
      case 'SMESelection':
        return <SMESelection sxx={sxx} {...data} />;
      case 'AbroadParcelWidget':
        return <AbroadSelection sxx={sxx} />;
      default:
        console.warn('Unknown component:', template);
        return null;
    }
  };
  return <>{selectComponent(template)}</>;
};

export default ContentfulComponent;
